import { useMemo } from 'react'
import { getConfig } from '../config'

export const useIsProduction = () => {
  return useMemo(() => getConfig().env === 'production', [])
}
